import { DrinkPricesBuilder } from "./drink.prices.builder";

export class DrinkPrices {
  public readonly monday: number;
  public readonly tuesday: number;
  public readonly wednesday: number;
  public readonly thursday: number;
  public readonly friday: number;
  public readonly saturday: number;
  public readonly sunday: number;
  constructor(builder: DrinkPricesBuilder) {
    this.monday = builder.monday;
    this.tuesday = builder.tuesday;
    this.wednesday = builder.wednesday;
    this.thursday = builder.thursday;
    this.friday = builder.friday;
    this.saturday = builder.saturday;
    this.sunday = builder.sunday;
  }
}
